import { useViewingDirection } from '@routes/Panorama/ViewingDirectionContext'

import Arrow from './userArrow.svg'

import type { PanoramaImage } from '@state/panorama.ts'

interface ViewingDirectionIndicatorProps {
  image: PanoramaImage
}

const r = 3

function UserIndicator({ image }: ViewingDirectionIndicatorProps) {
  const { x, y } = image
  const { azimuthalAngle, syncedImageId } = useViewingDirection()

  if (syncedImageId !== image.id) return null

  const yawDeg = image.yaw ?? 0
  const yawRad = (yawDeg * Math.PI) / 180
  const rotationDeg = -(azimuthalAngle + yawRad) * (180 / Math.PI)

  return (
    <image
      href={Arrow}
      x={x - r / 2}
      y={y - r / 2}
      height={r}
      width={r}
      transform={`rotate(${rotationDeg}, ${x}, ${y})`}
    />
  )
}

export default UserIndicator
